import tinycolor from 'tinycolor2';
import { colors } from 'styles/common';
const getCustomColors = (color, textColor, hoverColor) => {
    const customColor = color;
    const customTextColor = textColor || colors.white;
    const customHoverColor = hoverColor || color;
    return {
        customColor,
        customTextColor,
        customHoverColor: tinycolor(customHoverColor)
            .saturate(10)
            .darken(10)
            .toString(),
    };
};
const buttonColors = {
    primary: getCustomColors(colors.green),
    secondary: getCustomColors(colors.yellow),
    black: getCustomColors(colors.black),
    danger: getCustomColors(colors.red),
    grey: getCustomColors(colors.grey20, colors.grey100),
    basic: getCustomColors(colors.white, colors.grey100),
    link: getCustomColors('transparent', colors.grey100, 'transparent'),
};
export const getButtonColors = (appearance) => {
    return buttonColors[appearance] || buttonColors.primary;
};
